export type {
  CatalogComponentDef,
  CatalogSchema,
  ComponentSpec,
  EmittedEvent,
  EventBinding,
  PropSchema,
  RegisteredCatalog,
} from './types.js';
export { registerCatalog, validateSpec } from './registry.js';
export { render } from './renderer.js';
export type { RenderOptions } from './renderer.js';
